
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

interface PromptAuthorProps {
  id: string;
  name: string;
  createdAt: string;
  onClick?: (e: React.MouseEvent) => void;
}

const PromptAuthor: React.FC<PromptAuthorProps> = ({ 
  id, 
  name, 
  createdAt,
  onClick 
}) => {
  const navigate = useNavigate();
  
  // Get initials for avatar fallback
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  const formattedDate = new Date(createdAt).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
  
  const handleProfileClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (onClick) onClick(e);
    
    // Navigate to profile page
    if (id) {
      console.log(`Navigating to profile: /profile/${id}`);
      navigate(`/profile/${id}`);
    } else {
      console.log("No user id available for profile navigation");
    }
  };

  return (
    <div className="flex justify-between items-center mt-4 text-xs text-muted-foreground flex-wrap gap-2">
      <div 
        className="flex items-center gap-2 hover:text-primary transition-colors cursor-pointer" 
        onClick={handleProfileClick}
      >
        <Avatar className="h-6 w-6 flex-shrink-0">
          <AvatarFallback className="text-xs">
            {getInitials(name)}
          </AvatarFallback>
        </Avatar>
        <span className="font-medium break-words">{name}</span>
      </div>
      <span className="flex-shrink-0">{formattedDate}</span>
    </div>
  );
};

export default PromptAuthor;
